import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallingVoicemailIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CallingVoicemail",
    children: /*#__PURE__*/_jsx("path", {
      d: "M8.45 22.48c-3.58 0-6.45-2.9-6.45-6.47s2.9-6.48 6.48-6.48 6.48 2.9 6.48 6.48c0 1.49-.51 2.9-1.43 4.05h4.92a6.4 6.4 0 0 1-1.43-4.05c0-3.58 2.9-6.48 6.48-6.48s6.48 2.9 6.48 6.48-2.66 6.26-6.06 6.47H8.42Zm.03-10.53c-2.24 0-4.06 1.82-4.06 4.06s1.69 3.95 3.85 4.06h.46c2.13-.13 3.81-1.92 3.81-4.05s-1.82-4.06-4.06-4.06Zm15.03 0c-2.24 0-4.06 1.82-4.06 4.06s1.67 3.92 3.82 4.05h.5c2.14-.13 3.82-1.91 3.82-4.05s-1.82-4.06-4.06-4.06z"
    })
  }));
};